
import { defineComponent, ref, reactive, toRefs, onMounted, watch, nextTick, computed } from 'vue'
import { DoubleRightOutlined } from '@ant-design/icons-vue'
import router from '@/router/index'
import { useRoute } from 'vue-router'
import Navatop from '@/components/navtop.vue'
import f10Api from '@/api/f10Api'
import { init, ECharts, EChartsOption } from 'echarts'
import Table from '@/components/table.vue'
import Drawer from '@/components/drawer.vue'
import Charts from '@/components/page/charts.vue'
import globalsets from '@/utils/globalsets'
import Nodata from '@/components/page/nodata.vue'
export default defineComponent({
  props: {
    itemdata: {
      type: Object,
      default: () => {
        return {}
      }
    },
    pageSourceData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    token: {
      type: String,
      default: () => {
        return ''
      }
    },
    currentsharesData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  components: { Table, Drawer, Charts, Nodata },
  setup(props, context) {
    const myChart1: any = reactive({})
    const myChart2: any = reactive({})
    const color = globalsets.getColor()
    const pageData: any = reactive({
      list1: [],
      list2: [],
      data: [],
      data2: [],
      columns: [],
      columns2: [],
      visible: false,
      drawerdata: {},
      option: {},
      option2: {},
      optiongd_detail: {},
      spinning: true,
      radiovalue: '',
      radiolist: [],
      total2: 0,
      // 当前股东信息
      currentshareholder: {},
      pagination2: {},
      overflow: {},
      getPopupContainer: (e: HTMLElement) => e.parentNode,
      getContainer: () => document.querySelector('.hashwrapper'),
      currentsharesData: props.currentsharesData
    })
    pageData.pagination2 = computed(() => {
      return {
        total: pageData.total2,
        showSizeChanger: true,
        showTotal: (total: any) => `共${pageData.total2}条`,
        pageSizeOptions: ['10', '20', '50', '100'],
        onChange: changesize,
        onShowSizeChange: changesize
      }
    })
    pageData.list1 = [
      {
        title: '十大流通股东持股'
      },
      {
        title: '其余流通股份'
      },
      {
        title: '流通受限股份'
      }
    ]
    pageData.columns = [
      {
        title: '名次',
        dataIndex: 'Rank',
        key: 'Rank',
        width: '60px',
        slots: { customRender: 'spotColor' }
      },
      {
        title: '股东名称',
        dataIndex: 'SHName',
        key: 'SHName',
        width: '180px',
        ellipsis: true,
        slots: { customRender: 'ellipsis' }
      },
      {
        title: '股东性质',
        dataIndex: 'SHNature',
        key: 'SHNature',
        width: '120px',
        ellipsis: true,
        slots: { customRender: 'ellipsis' }
      },
      {
        title: '股份类型',
        dataIndex: 'ShareType',
        key: 'ShareType',
        width: '110px',
        ellipsis: true,
        slots: { customRender: 'ellipsis' }
      },
      {
        title: '持股数(股)',
        dataIndex: 'HoldSum',
        key: 'HoldSum',
        width: '90px',
        slots: { customRender: 'peopleCount' }
      },
      {
        title: '占总流通股本比例',
        dataIndex: 'PCTOfFloatShares',
        key: 'PCTOfFloatShares',
        width: '120px',
        slots: { customRender: 'nocolorincrease' }
      },
      {
        title: '增减(股)',
        dataIndex: 'IncreaseOrReduce',
        key: 'IncreaseOrReduce',
        width: '80px',
        slots: { customRender: 'peopleCountColor' }
      },
      {
        title: '变动比例',
        dataIndex: 'ChangeRatio',
        key: 'ChangeRatio',
        width: '80px',
        slots: { customRender: 'increase' }
      }
    ]
    pageData.columns2 = [
      {
        title: '报告期',
        dataIndex: 'time',
        key: 'time',
        width: '100px'
      },
      {
        title: '持股数(股)',
        dataIndex: 'HoldSum',
        key: 'HoldSum',
        width: '100px',
        slots: { customRender: 'peopleCount' }
      },
      {
        title: '占总流通股本比例',
        dataIndex: 'PCTOfFloatShares',
        key: 'PCTOfFloatShares',
        width: '120px',
        slots: { customRender: 'nocolorincrease' }
      },
      {
        title: '增减(股)',
        dataIndex: 'IncreaseOrReduce',
        key: 'IncreaseOrReduce',
        width: '100px',
        slots: { customRender: 'peopleCountColor' }
      }
    ]
    // 显示抽屉
    const route = useRoute()
    function showdrawer(PageID: number, PageSize: number, data: any) {
      pageData.visible = true
      if (data) {
        pageData.currentshareholder = Object.assign(data.record, props.currentsharesData)
      }
      getData2(PageID, PageSize)
    }
    function changesize(obj: any) {
      getData2(obj.PageID, obj.PageSize)
    }
    function getData2(PageID: number, PageSize: number) {
      const _data: any = {}
      _data.data = {
        Inst: route.query.code,
        Exch: route.query.market,
        PageID: PageID,
        PageSize: PageSize,
        Tp: 2,
        Name: pageData.currentshareholder.SHName
      }
      _data.headers = {
        token: props.token
      }
      f10Api.getholderholdestockhis(_data).then((res: any) => {
        pageData.drawerdata = res.Data
        const data = JSON.parse(JSON.stringify(res.Data))
        if (data && (data.Detail || []).length) {
          data.Detail.forEach((item: any, i: number) => {
            item.index = 'holdestockhis1' + i
            item.timer = 'holdestockhis1' + i + new Date().getTime()
            item.time = item.EndDate ? window.moment(item.EndDate * 1000).format('YYYY-MM-DD') : '—'
          })
        }
        pageData.total2 = data.Total
        pageData.data2 = data.Detail
        nextTick(() => {
          setgdDetail()
        })
      })
    }
    // 关闭抽屉
    function onClose() {
      pageData.visible = false
    }
    function setgdDetail() {
      // optiongd_detail
      pageData.optiongd_detail = {}
      const data = JSON.parse(JSON.stringify(pageData.drawerdata)).Detail
      if (!data || !data.length) return
      const xAxis = data.map((item: any) => window.moment(item.EndDate * 1000).format('YYYY-MM-DD')).reverse()

      const arr1 = data.map((item: any) => item.HoldSum)
      const arr2 = data.map((item: any) => item.PCTOfFloatShares)

      const max1 = Math.max.apply(null, arr1)
      const max2 = Math.max.apply(null, arr2)
      pageData.optiongd_detail = {
        color: color,
        tooltip: {
          trigger: 'axis',
          formatter: function(params: any) {
            var htmlStr = ''
            htmlStr += '<div class="optiontooltip" style="font-size: 12px"><p style="color:rgba(0,0,0,0.45);margin-bottom: 8px">' + params[0].name + '</p>'
            for (var i = 0; i < params.length; i++) {
              // 前面的原点和他的颜色
              let value = String(globalsets.getNumber(params[i].value))
              let style = 'height: 8px;'
              if (i === 1) {
                value = value + '%'
                style = 'height: 2px;'
              }
              htmlStr +=
                '<span style="width: 8px;' +
                style +
                'vertical-align: middle;display:inline-block;margn-right: 4px;background-color:' +
                params[i].color +
                '"></span><span style="color:#000;margin-left: 6px;">' +
                params[i].seriesName +
                ':</span>' +
                '<span style="color:#000;float:right;margin-left: 12px">' +
                value +
                '</span><br/>'
            }
            htmlStr += '</div>'
            return htmlStr
          }
        },
        grid: [
          {
            top: 40,
            left: 10,
            right: 10,
            bottom: 50,
            containLabel: true
          }
        ],
        toolbox: {
          feature: {}
        },
        legend: [
          {
            bottom: 20,
            itemWidth: 8,
            left: '188',
            itemHeight: 8,
            data: [
              {
                name: '持股数（股）', // 图例文字内容
                icon: 'rect',
                textStyle: {
                  color: '#7D7D7D'
                }
              }
            ]
          },
          {
            bottom: 20,
            itemWidth: 8,
            left: '288',
            itemHeight: 2,
            data: [
              {
                name: '持股比例', // 图例文字内容
                icon: 'rect',
                textStyle: {
                  color: '#7D7D7D'
                }
              }
            ]
          }
        ],
        xAxis: [
          {
            type: 'category',
            data: xAxis,
            axisPointer: {
              type: 'shadow'
            }
          }
        ],
        yAxis: [
          {
            name: '持股数（股）',
            type: 'value',
            interval: Math.ceil(Math.ceil(max1) / 4),
            max: Math.ceil(Math.ceil(max1) / 4) * 4
          },
          {
            name: '持股比例',
            type: 'value',
            interval: Math.ceil(Math.ceil(max2) / 4),
            max: Math.ceil(Math.ceil(max2) / 4) * 4,
            axisLabel: {
              formatter: function(value: any) {
                return (value || 0).toFixed(2) + '%'
              }
            }
          }
        ],
        series: [
          {
            name: '持股数（股）',
            type: 'bar',
            yAxisIndex: 0,
            barWidth: 20,
            data: data.map((item: any) => item.HoldSum).reverse()
          },
          {
            name: '持股比例',
            type: 'line',
            yAxisIndex: 1,
            lineStyle: {
              width: 1
            },
            showSymbol: false,
            data: data.map((item: any) => (parseFloat(item.PCTOfFloatShares).toString() !== 'NaN' ? item.PCTOfFloatShares.toFixed(2) : null)).reverse()
          }
        ]
      }
    }
    function setData() {
      const data = JSON.parse(JSON.stringify((props.pageSourceData || {}).TopTenCirculateSH))
      const currentdata: any = data.filter((item: any) => window.moment(item.EndDate * 1000).format('YYYY-MM-DD') === pageData.radiovalue)
      const _data = currentdata[0].ShareholderList
      _data.forEach((item: any, i: number) => {
        item.index = 'ShareholderList' + i
        item.color = color[i]
      })
      _data.push(currentdata[0].Summary)
      _data[_data.length - 1].index = 'ShareholderList11'
      pageData.data = _data
      const list1 = currentdata[0].CirculateShare
      pageData.list2 = pageData.data.slice(0, 10)
      setoption1(list1)
      setoption2()
    }
    function setoption1(list: any) {
      const data = JSON.parse(JSON.stringify(list))
      const seriesdata: any = [
        {
          name: '十大流通股东持股',
          value: data.TopTenCirculateHold * 100
        },
        {
          name: '其余流通股份',
          value: data.OtherCirculateHold * 100
        },
        {
          name: '流通受限股份',
          value: data.RestrictedCirculate * 100
        }
      ]
      pageData.option = {
        color: ['#0060FF', '#00D894', '#F6BD16'],
        tooltip: {
          trigger: 'item',
          position: 'right',
          formatter: function(params: any) {
            const { data, color } = params
            // '{b}<br /> <i style="width: 10px;height: 10px;border-radius: 50%;"></i>比例： {d}%'
            return `<div style="font-size: 12px"><p>${
              data.name
            }</p><div style="width: 10px;height: 10px;border-radius: 50%;display:inline-block;background-color: ${color}"></div> 比例： ${data.value.toFixed(
              2
            )}%</div>`
          }
        },
        legend: {
          show: false
        },
        series: [
          {
            // name: seriesdata.map((item: any) => item.name),
            type: 'pie',
            radius: '60%',
            center: [80, ' 40%'],
            data: seriesdata,
            labelLine: {
              show: false
            },
            label: {
              show: false,
              position: 'center'
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      }
    }
    function setoption2() {
      const data = JSON.parse(JSON.stringify(pageData.data))
      // option2
      let seriesdata: any = data.map((item: any) => ({ name: item.SHName, value: item.PCTOfFloatShares }))
      seriesdata = seriesdata.slice(0, 10)
      pageData.option2 = {
        color: color,
        tooltip: {
          trigger: 'item',
          position: 'right',
          // textStyle: {
          //   overflow: 'break',
          //   width: '260px'
          // },
          formatter: function(params: any) {
            const { data, color } = params
            return `<div style="max-width: 500px;white-space: normal;font-size: 12px"><p>${
              data.name
            }</p><div style="width: 10px;height: 10px;border-radius: 50%;display:inline-block;background-color: ${color}"></div> 比例： ${data.value.toFixed(
              2
            )}%</div>`
          }
        },
        legend: {
          show: false
        },
        series: [
          {
            type: 'pie',
            radius: '60%',
            center: [80, ' 40%'],
            data: seriesdata,
            labelLine: {
              show: false
            },
            label: {
              show: false,
              position: 'center'
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      }
    }
    function changeradio() {
      setData()
    }
    let timer: any = null
    function isoverflow(item: any, e: any) {
      const index = item.index
      const tooltip: any = {}
      tooltip[index] = e.currentTarget.scrollWidth > e.currentTarget.clientWidth
      if (tooltip[index]) {
        if (!timer) {
          timer = setTimeout(() => {
            pageData.overflow[index] = true
          }, 400)
        }
      }
    }
    function hidetool(item: any, i: number) {
      const index = item.index
      if (timer) {
        setTimeout(() => {
          pageData.overflow[index] = false
          window.clearTimeout(timer)
          timer = null
        })
      }
    }
    watch(
      () => (props.pageSourceData || {}).TopTenCirculateSH,
      (val: any) => {
        // if (val.)
        const data = JSON.parse(JSON.stringify(val))
        if ((data || []).length) {
          pageData.radiolist = data.map((item: any) => window.moment(item.EndDate * 1000).format('YYYY-MM-DD'))
          pageData.radiovalue = pageData.radiolist[0]
          setData()
        }
        nextTick(() => {
          pageData.spinning = false
        })
      },
      { deep: true }
    )
    return {
      ...toRefs(pageData),
      myChart1,
      myChart2,
      color,
      showdrawer,
      onClose,
      changeradio,
      changesize,
      isoverflow,
      hidetool
    }
  }
})
